import React from 'react';

export default function CardFinalClient({ 
	client,
	details = false
}){
	if(details){
		return (
			<div className="card border-none bg-white text-gc-dark-blue p-3 h-100">
				<div className="d-flex align-items-center my-auto">
					<div className="mr-2">
						<i className="fa-regular fa-user-tag h5"></i>
					</div>
					<div>
						<span className="d-block h6 font-weight-bold m-0">
							{(client?.surname + ' ' + client?.name).truncate(20)}
						</span>
						{client?.phone && <span className="d-block small font-weight-normal" style={{lineHeight: '1rem'}}>{client?.phone}</span>}
						{
							client?.email && (client?.email_has_error ?
							<span className="d-block small font-weight-normal badge badge-danger mt-1" style={{lineHeight: '1rem'}}>{'email_error'.trad()}</span>
							:
							<span className="d-block small font-weight-normal" style={{lineHeight: '1rem'}}>{client?.email}</span>)
						}
						
						{/* <span className="d-block small" style={{lineHeight: '1rem'}}>{client?.email}</span> */}
					</div>
				</div>
			</div>
		)		
	}else{
		return (
			<div className="card border-none bg-white text-gc-dark-blue p-3 h-100">
				<div className="d-flex align-items-center m-auto">
					<div className="">
						<i className="fa-regular fa-user-tag h5"></i>
					</div>
					<div className="ml-2 card-btn-text">
						<span 
							className="d-block h6 font-weight-bold m-0" 
							style={{lineHeight: '1rem'}}
						>
							{(client?.surname + ' ' + client?.name).truncate(15)}
						</span>
					</div>
				</div>
			</div>
		)		
	};
}